import React from "react";
import { selectFormat } from "../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayComparison = (props) => {
  const { data, close } = props;
  const displayDate =
    data.activePayload?.[0]?.payload?.displayDate || data.activeLabel;

  return (
    <div>
      <XRayTooltipHeader date={displayDate} close={close} />

      <main className="standard-tooltip__main">
        {data.activePayload
          .sort((a, b) => b.value - a.value)
          .map((item, index) => (
            <div className="standard-tooltip__item" key={index}>
              <span className="standard-tooltip__key">
                <span
                  className="standard-tooltip__icon"
                  style={{
                    background: "#fc6d52",
                    opacity:
                      item.name === "thisYear"
                        ? 1
                        : item.name === "year2024"
                        ? 0.6
                        : 0.3,
                  }}
                />
                {item.name === "thisYear"
                  ? "This Year"
                  : item.name === "year2024"
                  ? "2024"
                  : "2023"}
              </span>
              <span className="standard-tooltip__value">
                {selectFormat("number", item.value)}
              </span>
            </div>
          ))}
      </main>
    </div>
  );
};
